<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="container">
        <div class="box">
          <div class="title">《法律声明及隐私政策》</div>
          <div class="cont">
            <div class="section">
              <p>提示条款</p>
              <p>您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴此，趣编网服务提供者（或简称“我们”）制定本《法律声明及隐私权政策》（下称“本政策 /本隐私权政策”）并提醒您：</p>
              <p>本政策适用于趣编网产品或服务。<span class="keynote">如我们关联公司的产品或服务中使用了趣编网提供的产品或服务（例如直接使用趣编网账户登录）但未设独立法律声明及隐私权政策的，则本政策同样适用于该部分产品或服务。</span></p>
              <p>需要特别说明的是，<span class="keynote">本政策不适用于其他第三方向您提供的服务，也不适用于趣编网另行独立设置法律声明及隐私权政策的产品或服务。</span>例如趣编网上的用户依托趣编网向您提供服务时，您向该用户提供的个人信息不适用本政策</p>
              <p><span class="keynote">在使用趣编网各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用趣编网各项产品或服务，即表示您已充分理解并同意本政策。</span>如对本政策内容有任何疑问、意见或建议，您可通过趣编网提供的各种联系方式与我们联系。</p>
            </div>

            <div class="section">
              <p>第一部分 定义</p>
              <p><span style="font-weight:bold;">趣编网：</span>指www.qvbian.com网站及客户端、小程序等。</p>
              <p><span style="font-weight:bold;">趣编网服务提供者：</span>指杭州趣编网络科技有限公司。</p>
              <p><span style="font-weight:bold;">个人信息：</span>指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
              <p><span style="font-weight:bold;">个人敏感信息：</span>包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。</p>
              <p><span style="font-weight:bold;">个人信息删除：</span>指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
            </div>

            <div class="section">
              <p>第二部分 法律声明</p>
              <p><span style="font-weight:bold;">权利归属</span></p>
              <p>除非趣编网另行声明，<span class="keynote">趣编网的所有产品、技术、软件、程序、数据及其他信息（包括文字、图标、图片、照片、音频、视频、图表、色彩组合、版面设计等）的所有权利（包括版权、商标权、专利权、商业秘密及其他相关权利）均归趣编网服务提供者及/或其关联公司所有。未经趣编网服务提供者及/或其关联公司许可，任何人不得以包括通过机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载等方式擅自使用趣编网内的任何内容。</span>如有宣传、展示等任何使用需要，您必须取得趣编网服务提供者及/或其关联公司事先书面授权。</p>
              <p><span style="font-weight:bold;">责任限制</span></p>
              <p>鉴于趣编网提供的信息发布服务属于电子公告牌（BBS）性质，趣编网上的商品信息（包括但不限于产品的描述和说明、相关图片、视频等）由用户自行提供并上传，由用户对其提供并上传的信息承担相应法律责任。趣编网服务提供者对此另有约定的，将在相关的协议或其他法律文本中与您进行明确。</p>
              <p>趣编网转载的作品（包括论坛内容）出于传递更多信息之目的，并不意味我们赞同其观点或已经证实其内容的真实性。</p>
              <p><span style="font-weight:bold;">知识产权保护</span></p>
              <p>我们尊重知识产权，反对并打击侵犯知识产权的行为。知识产权权利人若认为趣编网内容（包括但不限于趣编网用户发布的信息）侵犯其合法权益的，可以通过趣编网平台进行投诉，我们将在收到知识产权权利人合格通知后依据相应的法律法规以及平台规则及时处理。</p>
            </div>

            <div class="section">
              <p>第三部分 隐私政策</p>
              <p>本隐私权政策部分将帮助您了解以下内容：</p>
              <p>1、我们如何收集和使用您的个人信息</p>
              <p>2、我们如何使用 Cookie 和同类技术</p>
              <p>3、我们如何共享、转让、公开披露您的个人信息</p>
              <p>4、我们如何保护您的个人信息</p>
              <p>5、您如何管理您的个人信息</p>
              <p>6、我们如何处理未成年人的个人信息</p>
              <p>7、您的个人信息如何在全球范围转移</p>
              <p>8、本隐私权政策如何更新</p>
              <p>9、如何联系我们</p>
              <p><span style="font-weight:bold;">一、我们如何收集和使用您的信息</span></p>
              <p>我们会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
              <p><span style="font-weight:bold;">（一）帮助您成为我们的用户</span></p>
              <p>为成为我们的用户，以便我们为您提供服务，您需要提供手机号码、电子邮箱地址，并创建用户名和密码。如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的用户及提供上述信息。</p>
              <p><span class="keynote">在注册会员过程中，如果您提供以下额外信息补全个人资料，将有助于我们给您提供如会员生日特权等更个性化的会员服务：您的真实姓名、性别、出生年月日、居住地、您本人的真实头像。但如果您不提供这些信息，将会影响到您使用个性化的会员服务，但不会影响使用趣编网产品或服务的基本浏览、搜索、购买功能。</span></p>
              <p>在您主动注销账号时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。</p>
              <p><span style="font-weight:bold;">（二）我们在您使用服务过程中收集的信息</span></p>
              <p>为向您提供更契合您需求的页面展示和搜索结果、了解产品适配性、识别账号异常状态，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</p>
              <p>设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP 地址、GPS位置以及能够提供相关信息的Wi-Fi 接入点、蓝牙和基站等传感器信息）。</p>
              <p>日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。</p>
              <p><span class="keynote">请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。</span>如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
              <p>为展示您账户的订单信息，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。</p>
              <p>当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
              <p><span class="keynote">当您通过我们产品或服务使用上述服务时，您授权我们根据实际业务及合作需要从我们关联公司处接收、汇总、分析我们确认其来源合法或您授权同意其向我们提供的您的个人信息或交易信息。</span></p>
              <p><span class="keynote">如您拒绝提供上述信息或拒绝授权，可能无法使用我们关联公司的相应产品或服务，或者无法展示相关信息，但不影响使用趣编网的浏览、搜索等服务。</span></p>
              <p><span style="font-weight:bold;">（三）为您提供安全保障</span></p>
              <p><span class="keynote">请注意，为确保会员身份真实性、向您提供更好的安全保障，您可以向我们提供身份证、军官证、护照、驾驶证、社保卡、居住证等身份信息、面部特征等生物识别信息等个人敏感信息完成实名认证。</span></p>
              <p>为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或趣编网相关协议规则的情况，<span class="keynote">我们可能使用或整合您的账号信息、交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span></p>
              <p><span style="font-weight:bold;">（四）其他用途</span></p>
              <p>我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
              <p><span style="font-weight:bold;">（五）征得授权同意的例外</span></p>
              <p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
              <p>1、与国家安全、国防安全有关的；</p>
              <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
              <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
              <p>4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
              <p>5、所收集的个人信息是您自行向社会公众公开的；</p>
              <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
              <p>7、根据您的要求签订合同所必需的；</p>
              <p>8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
              <p>9、为合法的新闻报道所必需的；</p>
              <p>10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
              <p>11、法律法规规定的其他情形。</p>
              <p>如我们停止运营趣编网产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>
              <p><span style="font-weight:bold;">二、我们如何使用 Cookie 和同类技术</span></p>
              <p><span style="font-weight:bold;">（一）Cookie</span></p>
              <p>为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好或购物篮内的商品等数据。</p>
              <p>您可根据自己的偏好管理或删除 Cookie。有关详情，请参见<a href="https://www.aboutcookies.org/" target="_blank">AboutCookies.org</a>。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。</p>
              <p><span style="font-weight:bold;">（二）网站信标和像素标签</span></p>
              <p>除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</p>
              <p><span style="font-weight:bold;">三、我们如何共享、转让、公开披露您的个人信息</span></p>
              <p><span style="font-weight:bold;">（一）共享</span></p>
              <p>我们不会与趣编网服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>
              <p>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
              <p>2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
              <p>3、与关联公司间共享：<span class="keynote">为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护趣编网关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。</span>我们只会共享必要的个人信息（如为便于您使用趣编网账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</p>
              <p><span style="font-weight:bold;">（二）转让</span></p>
              <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
              <p>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
              <p>2、在趣编网服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
              <p><span style="font-weight:bold;">（三）公开披露</span></p>
              <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
              <p>1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
              <p>2、<span class="keynote">如果我们确定您出现违反法律法规或严重违反趣编网相关协议规则的情况，或为保护趣编网及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或相关协议规则征得您同意的情况下披露关于您的个人信息，</span>包括相关违规行为以及趣编网已对您采取的措施。</p>
              <p><span style="font-weight:bold;">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span></p>
              <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
              <p>1、与国家安全、国防安全有关的；</p>
              <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
              <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
              <p>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
              <p>5、您自行向社会公众公开的个人信息；</p>
              <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
              <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
              <p><span style="font-weight:bold;">四、我们如何保护您的个人信息安全</span></p>
              <p>（一）我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据（如信用卡信息）时受 SSL（Secure Socket Layer）协议加密保护；我们同时对趣编网网站提供HTTPS（Hyper Text Transfer Protocol over Secure Socket Layer）协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
              <p>（二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过ISO27001等认证。</p>
              <p>（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。<span class="keynote">我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span></p>
              <p>（四）互联网并非绝对安全的环境，<span class="keynote">我们强烈建议您不要使用非趣编网推荐的通信方式发送个人信息。</span>您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。</p>
              <p>在使用趣编网服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络趣编网客服，以便我们根据您的申请采取相应措施。</p>
              <p>请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
              <p>（五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过趣编网公告方式获得。</p>
              <p>（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
              <p>同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
              <p><span style="font-weight:bold;">五、您如何管理您的个人信息</span></p>
              <p>您可以通过以下方式访问及管理您的个人信息：</p>
              <p><span style="font-weight:bold;">（一）访问您的个人信息</span></p>
              <p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p>
              <p>账户信息——如果您希望访问或编辑您的账户中的个人基本资料信息和支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过登录账号通过“账号设置”执行此类操作。</p>
              <p>搜索信息——您可以登录账号通过“我的项目”访问您的项目历史记录。</p>
              <p>如果您无法通过上述路径访问该等个人信息，您可以随时通过趣编网客服与我们取得联系。我们将在15天内回复您的访问请求。</p>
              <p>对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条“（七）响应您的上述请求”中的相关安排向您提供。</p>
              <p><span style="font-weight:bold;">（二）更正或补充您的个人信息</span></p>
              <p>当您发现我们处理的关于您的个人信息有错误时，您有权做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式进行更正或补充。</p>
              <p><span style="font-weight:bold;">（三）删除您的个人信息</span></p>
              <p>您可以通过联系客服的方式删除您的部分个人信息。</p>
              <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
              <p>1、如果我们处理个人信息的行为违反法律法规；</p>
              <p>2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
              <p>3、如果我们处理个人信息的行为严重违反了与您的约定；</p>
              <p>4、如果您不再使用我们的产品或服务，或您主动注销了账号；</p>
              <p>5、如果我们永久不再为您提供产品或服务。</p>
              <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
              <p><span class="keynote">当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span></p>
              <p><span style="font-weight:bold;">（四）改变您授权同意的范围</span></p>
              <p>每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策“第三部分第一条”）。当您收回同意后，我们将不再处理相应的个人信息。<span class="keynote">但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span></p>
              <p><span style="font-weight:bold;">（五）个人信息主体注销账户 </span></p>
              <p>您可以自行在“注销账户”页面提交账户注销申请。</p>
              <p>在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
              <p><span style="font-weight:bold;">（六）约束信息系统自动决策</span></p>
              <p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害趣编网商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。</p>
              <p><span style="font-weight:bold;">（七）响应您的上述请求</span></p>
              <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
              <p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
              <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
              <p>1、与国家安全、国防安全有关的；</p>
              <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
              <p>3、与犯罪侦查、起诉、审判和执行判决等有关的；</p>
              <p>4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
              <p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
              <p>6、涉及商业秘密的。</p>
              <p><span style="font-weight:bold;">六、我们如何处理未成年人的个人信息</span></p>
              <p>如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。<span class="keynote">如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</span></p>
              <p>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
              <p><span style="font-weight:bold;">七、您的个人信息如何在全球范围转移</span></p>
              <p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
              <p>1、法律法规有明确规定；</p>
              <p>2、获得您的明确授权；</p>
              <p>3、您通过互联网进行跨境交易等个人主动行为。</p>
              <p>针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</p>
              <p><span style="font-weight:bold;">八、本隐私权政策如何更新</span></p>
              <p>我们的隐私权政策可能变更。</p>
              <p>未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面上发布对隐私权政策所做的任何变更。</p>
              <p>对于重大变更，我们还会提供更为显著的通知。</p>
              <p>本政策所指的重大变更包括但不限于：</p>
              <p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
              <p>2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；</p>
              <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
              <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
              <p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
              <p>6、个人信息安全影响评估报告表明存在高风险时。</p>
              <p><span style="font-weight:bold;">九、如何联系我们</span></p>
              <p>您可以通过以下方式与我们联系，我们将在15天内回复您的请求：</p>
              <p>1、如对本政策内容有任何疑问、意见或建议，您可通过在线客服与我们联系；</p>
              <p>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，<span class="keynote">您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</span></p>
            </div>           　
            
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'

  export default {
    components:{
      Header,
      Footer,
    },
  }
</script>

<style scoped>
  .main{
    padding: 30px 0 219px;
  }
  .box{
    padding: 30px;
    background: #ffffff;
  }
  .title{
    margin-bottom: 30px;
    text-align: center;
    font-size: 20px;
    color: #424753;
    font-weight: 600;
  }
  .section{
    margin-bottom: 20px;
  }
  .section p{
    font-size: 12px;
    line-height: 24px;
  }
  .section p:nth-child(1){
    font-weight: 600;
  }
  .section.fw p:nth-child(1){
    font-weight: normal;
  }
  .red{
    color: red;
  }
  .keynote{
    font-weight:bold; 
    text-decoration:underline;
    padding-left: 2px;
    padding-right: 2px; 
  }
</style>



// WEBPACK FOOTER //
// App.vue?bc956540